import React, { type ErrorInfo, useState } from 'react'

import { Box, Button, Paper, Stack, Typography } from '@mui/material'
import copyToClipBoard from 'copy-to-clipboard'

type ErrorFallbackProps = {
  error: Error
  info: ErrorInfo
  clearError: () => void
}

const ErrorFallback = ({ error, info, clearError }: ErrorFallbackProps) => {
  const [copied, setCopied] = useState(false)

  const details = [
    `Error: ${error?.message || error}`,
    `URL: ${window.location.href}`,
    `Time: ${new Date().toISOString()}`,
    '',
    'Stack:',
    error?.stack || '(none)',
    '',
    'Component stack:',
    info?.componentStack || '(none)',
  ].join('\n')

  const handleCopy = () => {
    copyToClipBoard(details)
    setCopied(true)
  }

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', p: 3 }}>
      <Paper sx={{ p: 4, maxWidth: 820, width: '100%' }}>
        <Typography gutterBottom variant="h5">
          Something went wrong
        </Typography>
        <Typography color="text.secondary">
          This page crashed. Copy the details and send them to the team, then reload.
        </Typography>
        <Typography color="error" sx={{ mt: 2, fontWeight: 600 }}>
          {error?.message || String(error)}
        </Typography>
        <Box
          component="pre"
          sx={{
            mt: 2,
            p: 2,
            bgcolor: 'grey.100',
            borderRadius: 1,
            overflow: 'auto',
            maxHeight: 320,
            fontSize: 12,
            whiteSpace: 'pre-wrap',
          }}>
          {details}
        </Box>
        <Stack direction="row" spacing={2} sx={{ mt: 3 }}>
          <Button onClick={handleCopy} variant="contained">
            {copied ? 'Copied!' : 'Copy error details'}
          </Button>
          <Button onClick={() => window.location.reload()} variant="outlined">
            Reload
          </Button>
          <Button onClick={clearError} variant="text">
            Try again
          </Button>
        </Stack>
      </Paper>
    </Box>
  )
}

export default ErrorFallback
